import { Link } from "gatsby";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import React from "react";

import * as headlineBannerStyles from "./HeadlineBanners.module.css";

const HeadlineBanners = ({ props }) => {
  const { banners, background } = props;

  return (
    <div
      className={`${headlineBannerStyles.bannersContainer} ${headlineBannerStyles[background]}`}
    >
      {banners.map((banner, index) => {
        const { headline, image, destination, textAlignment } = banner;
        const imageSrc = image && getImage(image.file);

        let headlineClass;
        switch (textAlignment) {
          case "left":
            headlineClass = headlineBannerStyles.headlineContainerLeft;
            break;
          case "right":
            headlineClass = headlineBannerStyles.headlineContainerRight;
            break;
          case "center":
            headlineClass = headlineBannerStyles.headlineContainerCenter;
            break;
          default:
            headlineClass = headlineBannerStyles.headlineContainerLeft;
        }

        return (
          <Link key={index} to={destination}>
            <div
              // data-aos="zoom-in-up"
              key={index}
              className={headlineBannerStyles.bannerContainer}
            >
              {image && (
                <>
                  <GatsbyImage
                    image={imageSrc}
                    alt={image.file.description}
                    className={headlineBannerStyles.backgroundImage}
                  />
                  <div className={headlineBannerStyles.veilOfDarkness}></div>
                </>
              )}
              <div
                className={`${headlineClass} ${
                  image ? headlineBannerStyles.whiteText : null
                }`}
              >
                <h5>{headline}</h5>
              </div>
            </div>
          </Link>
        );
      })}
    </div>
  );
};

export default HeadlineBanners;
